import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => {
  return {
    item: {
      paddingLeft: token.paddingXL
    },

    spin: {
      ' .ant-spin-dot-item': {
        color: `${token.blue7} !important`
      }
    }
  }
})
